// ruDevEdge.ts — CORE-1422: the Moscow edge in front of the DEV backend.
//
// From Russia every direct leg to our foreign hosts is shaped: a response dies
// around 16 KB and an upload body around 400 KB (measured 15.09.2026 against
// api.agdev.tmless.org). The dev backend is therefore reached through
// api.rudev.tmless.org — nginx on 93.183.74.165 — which carries REST, the
// SignalR hubs and both chat services on one host, onward through the Selectel
// relay (docs/infra/rudev.tmless.org.nginx.conf, ru-relay.nginx.conf).
//
// Kept apart from envSwitch.ts on purpose: apiUrl.ts needs the host list too,
// and must not pull in storage.

export const DEV_RU_EDGE_ORIGIN = 'https://api.rudev.tmless.org';

/** Dev backend roles as reached through the edge. Path prefixes are stripped by
 *  the edge (`/chat-api/`, `/agape-chat/`). */
export const DEV_RU_EDGE_HOSTS = {
  api: 'api.rudev.tmless.org',
  chatApi: 'api.rudev.tmless.org/chat-api',
  chatHub: 'api.rudev.tmless.org/agape-chat',
} as const;

/**
 * Web hosts served FROM the Moscow edge for the dev environment: the dev
 * frontend for Russia (`dev.agdev.tmless.org`, CORE-1422) and the older
 * `*.rudev.tmless.org` mirrors. A bundle loaded from one of them talks to the
 * dev backend through the edge as well — going direct would send the browser
 * straight back onto the shaped leg the page itself was moved off.
 */
export function isRuDevEdgeWebHost(host: string): boolean {
  return host === 'dev.agdev.tmless.org' || /(^|\.)rudev\.tmless\.org$/.test(host);
}

/**
 * CORE-2115 — the dev backend reached DIRECTLY, bypassing the Moscow edge. The
 * web fetch patch (apiFallback.ts) repeats a REST call here when the edge did not
 * answer at all: some Russian ISPs (Rostelecom, 05.11.2026) cut the connection to
 * `api.rudev.tmless.org` by SNI while `api.agdev.tmless.org` still answers. The
 * direct leg is shaped (~16 KB per response), so it is a fallback, not a default:
 * login, `/Auth/me`, `/features` are a few hundred bytes and get through.
 */
export const DEV_DIRECT_API_ORIGIN = 'https://api.agdev.tmless.org';
